var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ org: true, 'is-small': _vm.size === 'small' },attrs:{"title":"조직도"}},[_c('button',{staticClass:"org-button officehome-gnb-org",on:{"click":_vm.openOrgTree}},[_c('OrgTreeIcon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }